export default "__VITE_ASSET__5b046620__"